import React, { useState, useMemo } from 'react';
import styles from './ImportModal.module.css';
import Button from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';

const ImportModal = ({ isVisible, features, onClose, onImport }) => {
    const [selectedFeatureIds, setSelectedFeatureIds] = useState([]);

    // При открытии модального окна выделяем все объекты по умолчанию
    React.useEffect(() => {
        if (isVisible) {
            setSelectedFeatureIds(features.map(f => f.id));
        }
    }, [isVisible, features]);

    const handleToggleSelection = (featureId) => {
        setSelectedFeatureIds(prev =>
            prev.includes(featureId)
                ? prev.filter(id => id !== featureId)
                : [...prev, featureId]
        );
    };

    const handleToggleAll = () => {
        if (selectedFeatureIds.length === features.length) {
            setSelectedFeatureIds([]); // Снять все
        } else {
            setSelectedFeatureIds(features.map(f => f.id)); // Выделить все
        }
    };

    const handleConfirmImport = () => {
        const featuresToImport = features.filter(f => selectedFeatureIds.includes(f.id));
        onImport(featuresToImport);
        onClose();
    };

    const getFeatureDescription = (feature) => {
        const props = feature.properties || {};
        const type = props.type || 'Неизвестный тип';
        const name = props.name || props.cadastral_number || `ID: ${feature.id.substring(0, 8)}...`;
        return `${type} - ${name}`;
    };

    if (!isVisible) {
        return null;
    }

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <h3 className={styles.modalTitle}>Импорт объектов</h3>
                <p className={styles.modalDescription}>
                    Найдено {features.length} объектов в файле. Выберите, какие из них вы хотите импортировать.
                </p>

                <div className={styles.featureList}>
                    <div className={styles.listHeader}>
                        <Checkbox
                            checked={selectedFeatureIds.length === features.length && features.length > 0}
                            onChange={handleToggleAll}
                            label={`Выбрать все (${selectedFeatureIds.length}/${features.length})`}
                        />
                    </div>
                    {features.map(feature => (
                        <div key={feature.id} className={styles.featureItem}>
                            <Checkbox
                                checked={selectedFeatureIds.includes(feature.id)}
                                onChange={() => handleToggleSelection(feature.id)}
                                label={getFeatureDescription(feature)}
                            />
                        </div>
                    ))}
                </div>

                <div className={styles.modalActions}>
                    <Button variant="default" onClick={onClose}>
                        Отмена
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleConfirmImport}
                        disabled={selectedFeatureIds.length === 0}
                    >
                        Импортировать ({selectedFeatureIds.length})
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ImportModal;